document.addEventListener( 'wpcf7submit', function( event ) {
    console.log(event.detail.contactFormId);
    if ( event.detail.contactFormId == '7' || event.detail.contactFormId == '309'  ) {
        let inputs = [];
        for ( var i = 0; i < event.detail.inputs.length; i++ ) {
            inputs[event.detail.inputs[i].name] = event.detail.inputs[i].value;
        }

        let formData = new FormData();
		formData.append('prenom', inputs['prenom']);
        formData.append('nom', inputs['nom']);
        formData.append('email', inputs['email']);
        formData.append('telephone', inputs['telephone']);
        formData.append('sexe', inputs['genre'] == 'Homme' ? 'homme' : 'femme');
        formData.append('date_naissance', inputs['date_naissance']);
        formData.append('adresse1', inputs['adresse']);
        formData.append('cp', inputs['code_postal']);
        formData.append('ville', inputs['ville']);

        const XHR = new XMLHttpRequest();
        XHR.open("POST", "https://base2.quotas.ovh/api/subscription-contact");
        XHR.send(formData);
    }
}, false );